




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { Action } from 'vuex-class';

@Component({
  methods: {
    ...mapActions(['toggleSideBarAction']),
  },
})
export default class TopBar extends Vue {
   @Action('logoutAction') public logoutAction!: () => void;

   public logout(): void {
     this.logoutAction();
     this.$router.replace('/login');
   }
}
